export default {
  searchHistory: [],
  filterHistory: [],
  searchCache: {},
  cartCache: false,
  paymentType: 'bpo_price'
}
